"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlineInterval = exports.FundingChartInterval = exports.VirtualTradeType = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["OPEN"] = "OPEN";
    OrderStatus["FILLED"] = "FILLED";
    OrderStatus["CANCELLED"] = "CANCELLED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var VirtualTradeType;
(function (VirtualTradeType) {
    VirtualTradeType["MARKET"] = "MARKET";
    VirtualTradeType["LIMIT"] = "LIMIT";
    VirtualTradeType["RANGE"] = "RANGE";
    VirtualTradeType["LIQUIDATION"] = "LIQUIDATION";
    VirtualTradeType["TAKE_OVER"] = "TAKE_OVER";
})(VirtualTradeType || (exports.VirtualTradeType = VirtualTradeType = {}));
var FundingChartInterval;
(function (FundingChartInterval) {
    FundingChartInterval["HOUR"] = "1h";
    FundingChartInterval["EIGHT_HOUR"] = "8h";
})(FundingChartInterval || (exports.FundingChartInterval = FundingChartInterval = {}));
var KlineInterval;
(function (KlineInterval) {
    KlineInterval["MINUTE"] = "1m";
    KlineInterval["FIVE_MINUTE"] = "5m";
    KlineInterval["FIFTEEN_MINUTE"] = "15m";
    KlineInterval["THIRTY_MINUTE"] = "30m";
    KlineInterval["HOUR"] = "1h";
    KlineInterval["FOUR_HOUR"] = "4h";
    KlineInterval["WEEK"] = "1w";
    KlineInterval["DAY"] = "1d";
})(KlineInterval || (exports.KlineInterval = KlineInterval = {}));
